import { IconProps } from "./IconProps";

export const RepairsWidgetIcon = (props: IconProps) => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.49999 9.49999L16.625 16.625M9.49999 9.49999H4.74999L3.16666 4.74999L4.74999 3.16666L9.49999 4.74999V9.49999ZM30.4934 4.33993L26.333 8.50032C25.706 9.12735 25.3925 9.44086 25.275 9.80238C25.1717 10.1204 25.1717 10.4629 25.275 10.7809C25.3925 11.1425 25.706 11.456 26.333 12.083L26.7087 12.4587C27.3357 13.0857 27.6492 13.3992 28.0107 13.5167C28.3287 13.62 28.6713 13.62 28.9893 13.5167C29.3508 13.3992 29.6643 13.0857 30.2913 12.4587L34.183 8.56696C34.6022 9.58689 34.8333 10.7039 34.8333 11.875C34.8333 16.6845 30.9345 20.5833 26.125 20.5833C25.5452 20.5833 24.9786 20.5267 24.4304 20.4186C23.6607 20.2667 23.2758 20.1908 23.0425 20.2141C22.7945 20.2388 22.6722 20.276 22.4525 20.3936C22.2457 20.5042 22.0384 20.7116 21.6236 21.1264L10.2917 32.4583C8.97998 33.77 6.85333 33.77 5.54166 32.4583C4.22998 31.1466 4.22998 29.02 5.54166 27.7083L16.8736 16.3764C17.2884 15.9616 17.4957 15.7542 17.6064 15.5475C17.724 15.3277 17.7612 15.2055 17.7859 14.9574C17.8091 14.7241 17.7332 14.3393 17.5814 13.5695C17.4733 13.0214 17.4167 12.4548 17.4167 11.875C17.4167 7.06551 21.3155 3.16666 26.125 3.16666C27.717 3.16666 29.2093 3.59388 30.4934 4.33993ZM19.0001 23.7499L27.7083 32.4582C29.02 33.7698 31.1466 33.7698 32.4583 32.4582C33.77 31.1465 33.77 29.0198 32.4583 27.7081L25.2942 20.5442C24.7871 20.4962 24.2926 20.4047 23.8146 20.2735C23.1985 20.1044 22.5228 20.2272 22.0711 20.6789L19.0001 23.7499Z"
        stroke="#06123D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
